/**
 * Pattern di path che usano layout full-bleed (senza padding di .nora-page).
 * Aggiungere qui nuove route invece di duplicare CSS per pagina.
 * @type {RegExp[]}
 */
const FULL_BLEED_PATH_PATTERNS = [/^\/operatore\/[^/]+\/?$/]

/**
 * Path che matchano il pattern ma devono mantenere il padding standard (es. lista).
 * @type {Set<string>}
 */
const FULL_BLEED_EXCLUDED_PATHS = new Set(['/operatore/list'])

/**
 * Normalizza il pathname per confronti stabili (senza slash finale).
 * @param {string} pathname - Pathname da react-router
 * @returns {string} Pathname normalizzato
 */
const normalizePathname = (pathname) => {
  if (!pathname || pathname === '/') return '/'
  return pathname.replace(/\/+$/, '') || '/'
}

/**
 * Indica se il pathname corrente richiede il layout full-bleed nel PageContainer.
 * @param {string} pathname - Pathname da react-router (es. /operatore/27)
 * @returns {boolean} true se la pagina deve riempire l'area main senza padding
 */
export const isFullBleedPath = (pathname) => {
  if (FULL_BLEED_EXCLUDED_PATHS.has(normalizePathname(pathname))) return false
  return FULL_BLEED_PATH_PATTERNS.some((pattern) => pattern.test(pathname))
}
